export default __webpack_public_path__ + "static/media/team-6.7b787c52.png";